import { ExtractedOrderData } from './funzingDataExtractor';

const PHONE_RE = /טלפון:\s*(\d+)/;
// Upcoming class row: יום <day>׳ HH:MM DD/MM/YYYY
const UPCOMING_RE = /יום\s+[א-ש]׳?\s+(\d{2}:\d{2})\s+(\d{2})\/(\d{2})\/(\d{4})/;
// Name is the last non-empty line before "טלפון:"
const NAME_BEFORE_PHONE_RE = /([^\n]+)\n(?:\s*\n)*טלפון:/;

export function extractOrderDataFromLeap(text: string): ExtractedOrderData {
  const phoneMatch = text.match(PHONE_RE);
  const upcomingMatch = text.match(UPCOMING_RE);
  const nameMatch = text.match(NAME_BEFORE_PHONE_RE);

  let firstName: string | null = null;
  let lastName: string | null = null;
  if (nameMatch) {
    const parts = nameMatch[1].trim().split(/\s+/);
    firstName = parts[0] ?? null;
    lastName = parts.length > 1 ? parts[parts.length - 1] : null;
  }

  let date: string | null = null;
  let time: string | null = null;
  if (upcomingMatch) {
    const [, hhmm, day, month, year] = upcomingMatch;
    date = `${year}-${month}-${day}`;
    time = hhmm;
  }

  return {
    firstName,
    lastName,
    date,
    time,
    persons: null,
    phone: phoneMatch ? phoneMatch[1] : null,
    source: 'externalPrefill.sources.leap',
  };
}
